// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"7eef3e22075a662a8287","453":"35de74f348bdf41837fe","454":"d84ee108b0701f0d53ea"}[chunkId] + ".js";
};